/** Sticky toolbar helpers for Configure → Business screens. */

export const STICKY_HEADER_OFFSET = 64;

export function isStickyHeaderStuck(sentinelEl, offset = STICKY_HEADER_OFFSET) {
    if (!sentinelEl || typeof sentinelEl.getBoundingClientRect !== 'function') {
        return false;
    }
    return sentinelEl.getBoundingClientRect().top <= offset;
}
